import script from "./ServerSettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerSettingsView.vue?vue&type=script&setup=true&lang=js"

import "./ServerSettingsView.vue?vue&type=style&index=0&id=75ba7623&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75ba7623"]])

export default __exports__